export const BACKEND_URL =
  process.env.BACKEND_URL !== undefined && process.env.BACKEND_URL !== ""
    ? process.env.BACKEND_URL
    : "https://vast-waters-64561.herokuapp.com/";
export const WEBSOCKET_URL =
  process.env.WEBSOCKET_URL !== undefined && process.env.WEBSOCKET_URL !== ""
    ? process.env.WEBSOCKET_URL
    : "wss://vast-waters-64561.herokuapp.com/websocket";
